/**
 * @file header
 * @author fengfaxia(fengfaxia@baidu.com))
 * Copyright (c) 2018-07-18 Baidu
 */

import React from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {Menu, Button, Dropdown} from 'antd';
import Login from '../Login/index';
import {
    getUserInfo,
    setCurrentPage
} from '../../actions/generalAction';
import {getBduss} from '../../actions/fetchAction';
import logo from '../../img/logo@1x.png';
import newIcon from '../../img/icon-new.png';
import {getDwzConsoleUrl} from '../../common/util';
import {getDwzConsolePackageUrl} from '../../common/util';

const {SubMenu} = Menu;

class Header extends React.Component {
    componentWillMount() {
        // 为了跨产品登录，先模拟登录的流程向后端发起请求，这样确保BDUSS有效性
        if (!this.props.userName) {
            getBduss().then(data => {
                this.props.dispatch(getUserInfo());
            });
        }
        // 为了兼容Safari浏览器，部分浏览器getBduss API没返回值，让userInfo 2s后请求，确保bduss/write执行完
        const me = this;
        setTimeout(() => {
            if (!me.props.userName) {
                me.props.dispatch(getUserInfo());
            }
        }, 2000);
        // 刷新或直接进入设置当前page
        this.setCurrentPage();
    }
    setCurrentPage() {
        const url = window.location.pathname;
        /* eslint-disable */
        const currentPage = url && url.match(/console\/(\S*)/) && url.match(/console\/(\S*)/)[1] || 'home';
        /* eslint-enable */
        this.props.dispatch(setCurrentPage(currentPage));
    }
    handleKeyClick({key}) {
        this.props.dispatch(setCurrentPage(key));
        const path = key === 'home' ? '/' : `/console/${key}`;
        /* eslint-disable */
        _hmt.push(['_trackPageview', path]);
    }
    handleConsoleClick() {
        /* eslint-disable */
        _hmt.push(['_trackEvent', '充值中心', 'hompage_click_charge', '点击充值中心']);
    }
    // menuLinkToSpp(){
    //     /* eslint-disable */
    //     _hmt.push(['_trackEvent', '顶部导航栏', 'menu_click_spp', '顶部导航跳转移动推送']);
    // }
    render() {
        let showElem = '';
        let styleVar = '';
        let userFreePoint = this.props.freePoint;
        if (userFreePoint < 0) {
            userFreePoint = 0;
        }
        const menu = (
            <Menu>
             <Menu.Item key = "logout">
                {
                    // 判断登录用户是否为付费用户
                    this.props.paid
                    // 判断登录用户是否欠费
                    ? this.props.inArrears
                    ? (showElem = 'none', styleVar = '160px')
                    : <div className = "free-point-paid">
                    <p>可用免费点数：{userFreePoint}</p>
                    <p>可用付费点数：<a
                    onClick={() => {this.handleConsoleClick();}}
                    target="_blank"
                    href={getDwzConsolePackageUrl()}
                    >点击查看</a></p>
                    </div>
                    : <div className = "free-point">
                    <p>可用免费点数：{userFreePoint}</p>
                    </div>
                }
             </Menu.Item>
           </Menu>
         );
        if (this.props.userName) {
            return (
                     <div className="header">
                    <Link to="/" className="logo"><img src={logo} width="145px" height="40px" /></Link>
                    <Menu
                        mode="horizontal"
                        onClick={e => this.handleKeyClick(e)}
                        selectedKeys={[this.props.currentPage]}>
                        <Menu.Item key="operation"><Link to="/console/operation">首页</Link></Menu.Item>
                        <SubMenu title="数据报表">
                            <Menu.Item key="report"><Link to="/console/report">基础报表</Link></Menu.Item>
                            <Menu.Item key="senior"><Link to="/console/advanced_report">高级报表</Link></Menu.Item>
                        </SubMenu>
                        <Menu.Item key="product">
                            <Link to="/console/product">
                                产品服务
                            </Link>
                        </Menu.Item>
                        <SubMenu title="产品文档">
                            <Menu.Item key="apidoc"><Link to="/console/apidoc">接口文档</Link></Menu.Item>
                            <Menu.Item key="price"><Link to="/console/price">产品价格</Link></Menu.Item>
                            <Menu.Item key="sla"><Link to="/console/sla">SLA</Link></Menu.Item>
                            <Menu.Item key="faq"><Link to="/console/faq">常见问题</Link></Menu.Item>
                        </SubMenu>
                        <Menu.Item key="userinfo"><Link to="/console/userinfo">token设置</Link></Menu.Item>
                        {/* <Menu.Item key="cece">
                            <a href="https://growing.baidu.com/spp.html" target="_blank" onClick={() => this.menuLinkToSpp()} >
                                <div className="new-icon">移动推送<img src={newIcon} style={{height: 22}} /></div>
                            </a>
                        </Menu.Item> */}
                    </Menu>
                    <Button
                        onClick={() => {this.handleConsoleClick();}}
                        target="_blank"
                        href={getDwzConsoleUrl()}
                        className="pay-btn"
                        style={{right: styleVar}}>充值中心</Button>
                    <Dropdown overlay={menu}>
                        <Button
                        style={{display: showElem}}
                        target="_blank"
                        className="query-btn">点数查询</Button>
                    </Dropdown>
                    <Login userName={this.props.userName} inArrears={this.props.inArrears}/>
                </div>
            );
        }
        return (
            <div className="header">
                <Link to="/" className="logo"><img src={logo} width="145px" height="40px" /></Link>
                <Menu
                    mode="horizontal"
                    onClick={e => this.handleKeyClick(e)}
                    selectedKeys={[this.props.currentPage]}>
                    <Menu.Item key="operation"><Link to="/console/operation">首页</Link></Menu.Item>
                    <SubMenu title="数据报表">
                        <Menu.Item key="report"><Link to="/console/report">基础报表</Link></Menu.Item>
                        <Menu.Item key="senior"><Link to="/console/advanced_report">高级报表</Link></Menu.Item>
                    </SubMenu>
                    <Menu.Item key="product">
                        <Link to="/console/product">
                            产品服务
                        </Link>
                    </Menu.Item>
                    <SubMenu title="产品文档">
                        <Menu.Item key="apidoc"><Link to="/console/apidoc">接口文档</Link></Menu.Item>
                        <Menu.Item key="price"><Link to="/console/price">产品价格</Link></Menu.Item>
                        <Menu.Item key="sla"><Link to="/console/sla">SLA</Link></Menu.Item>
                        <Menu.Item key="faq"><Link to="/console/faq">常见问题</Link></Menu.Item>
                    </SubMenu>
                    {/* <Menu.Item key="cece">
                        <a href="https://growing.baidu.com/spp.html" target="_blank" onClick={() => this.menuLinkToSpp()} >
                            <div className="new-icon">移动推送<img src={newIcon} style={{height: 22}} /></div>
                        </a>
                    </Menu.Item> */}
                </Menu>
                <Login /></div>
        );
    }
}
export default connect(state => ({
    currentPage: state.currentPage,
    userName: state.userName,
    freePoint: state.freePoint,
    paid: state.paid,
    inArrears: state.inArrears,
}))(Header);
